import { doAPIRequest as apiRequest } from '../api.js';

const API_CALL = '@komigen/mobile-frontend/store/middleware/API_CALL';

export const createApiMiddlewareAction = ({
	endpoint,
	method,
	payload,
	onStart,
	onSuccess,
	onError,
	onFinally,
	options
}) => ({
	type: API_CALL,
	payload: {
		endpoint,
		method,
		payload,
		onStart,
		onSuccess,
		onError,
		onFinally,
		options
	}
});

export const errorHandler =
	({ errorActionCreatorMap, defaultErrorActionCreator }) =>
	(statusCode, ...rest) =>
	dispatch => {
		const actionCreator =
			errorActionCreatorMap[statusCode] ||
			errorActionCreatorMap[statusCode - (statusCode % 100)] ||
			defaultErrorActionCreator;
		return dispatch(actionCreator(statusCode, ...rest));
	};

export const handleApiAction = apiAction => async dispatch => {
	const {
		endpoint = '/',
		method = 'GET',
		payload = {},
		onStart,
		onSuccess,
		onError,
		onFinally,
		options = {}
	} = apiAction.payload;

	const { urlencodedContentType, netellerHeaders, additionalHeaders, additionalOptions } = {
		...{
			urlencodedContentType: false,
			netellerHeaders: false,
			additionalHeaders: {},
			additionalOptions: {}
		},
		...options
	};

	if (onStart) {
		dispatch(onStart());
	}

	try {
		const response = await apiRequest({
			endpoint,
			payload,
			method,
			urlencodedContentType,
			netellerHeaders,
			additionalHeaders,
			additionalOptions
		});

		if (response.ok) {
			if (onSuccess) {
				const jsonString = await response.text();
				const json = jsonString ? JSON.parse(jsonString) : {};
				return dispatch(onSuccess(json, response.status, response.statusText));
			}
		} else {
			// Create a real Error object with useful info
			const error = new Error(`API Error: ${response.status} ${response.statusText}`);
			error.response = response; // Attach response for more context
			throw error;
		}
	} catch (error) {
		// Now 'error' will be a proper Error object
		if (onError) {
			// Extract status from response or use a default
			const status = error.response?.status || 0;
			const statusText = error.response?.statusText || error.message;
			dispatch(onError(status, statusText, error));
		}
		throw error; // Always throw the original error for proper error handling
	} finally {
		if (onFinally) {
			dispatch(onFinally());
		}
	}
};

// refrain from using this for now, use the createApiAction wrapper instead
export const apiMiddleware =
	({ dispatch }) =>
	next =>
	action => {
		if (action.type !== API_CALL) return next(action);
		return handleApiAction(action)(dispatch);
	};

export const createApiAction = args => handleApiAction(createApiMiddlewareAction(args));
